import { enableProdMode } from '@angular/core';
import { FIREBASE_OPTIONS } from '@angular/fire';
import { ConfigService } from '@caroo/config/config.service';
import { environment } from './environments/environment';
import * as __NgCli_bootstrap_1 from "./app/app.module.ngfactory";
import * as __NgCli_bootstrap_2 from "@angular/platform-browser";
if (environment.production) {
    enableProdMode();
}
__NgCli_bootstrap_2.platformBrowser([{
        provide: FIREBASE_OPTIONS,
        useValue: new ConfigService().firebase
    }])
    .bootstrapModuleFactory(__NgCli_bootstrap_1.AppModuleNgFactory)
    .catch(err => console.log(err));
